module.exports = __webpack_public_path__ + "img/swiper-button-prev.50b453c1.svg";